import isGHMC, {
  formattedDate,
  getCurrentDate,
  getCurrentDateTime,
  getStartOfCurrentDate,
} from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useEffect, useState } from "react";
import NoOfBinsGvpReportStore from "./store/NoOfBinsGvpReportStore";
import { NoOfBinsExport } from "./NoOfBinsExport";

export const NoOfBinsFilter = () => {
  const isProd = isGHMC();
  const { fetchNoOfBinsGvpOuterReport, noOfBinsGvpData } =
    NoOfBinsGvpReportStore();

  /* ================= FORMAT FOR datetime-local ================= */
  const formatForDateTimeLocal = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  /* ================= DEFAULT VALUES (current datetime) ================= */
  const defaultValues = {
    StartDate: getCurrentDate(),
    EndDate: getCurrentDate(),
  };

  /* ================= LOAD FROM LOCALSTORAGE OR DEFAULT ================= */
  const getInitialFilters = () => {
    const stored = localStorage.getItem("noOfBinsGvpFilters");
    return stored ? JSON.parse(stored) : defaultValues;
  };

  const [initialFilterValues, setInitialFilterValues] = useState(getInitialFilters());

  /* ================= FETCH DATA ON MOUNT & STORE IN LOCALSTORAGE ================= */
  useEffect(() => {
    // Fetch data using initial filters
    fetchNoOfBinsGvpOuterReport(initialFilterValues);

    // Save to localStorage if not already saved
    localStorage.setItem("noOfBinsGvpFilters", JSON.stringify(initialFilterValues));
  }, []);

  /* ================= SEARCH ================= */
  const handleSubmit = (values, { setSubmitting }) => {
    // Save filter to localStorage only on search
    localStorage.setItem("noOfBinsGvpFilters", JSON.stringify(values));
    setInitialFilterValues(values);

    fetchNoOfBinsGvpOuterReport(values);
    setSubmitting(false);
  };

  /* ================= RESET ================= */
  const handleReset = (resetForm) => {
    // Reset to current date/time, do NOT read localStorage
    resetForm({ values: defaultValues });
    setInitialFilterValues(defaultValues);

    // Update localStorage
    localStorage.setItem("noOfBinsGvpFilters", JSON.stringify(defaultValues));

    fetchNoOfBinsGvpOuterReport(defaultValues);
  };

  return (
    <Formik
      initialValues={initialFilterValues}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, resetForm }) => (
        <Form>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex align-items-end gap-2 mb-2">

              {/* From Date */}
              <div style={{ width: "200px" }}>
                <label className="form-label w-100 text-left">From Date</label>
                <Field
                  type="date"
                  name="StartDate"
                  className="form-control bg-white"
                  max={values.EndDate}
                  required
                />
              </div>

              {/* To Date */}
              <div style={{ width: "200px" }}>
                <label className="form-label w-100 text-left">To Date</label>
                <Field
                  type="date"
                  name="EndDate"
                  className="form-control bg-white"
                  min={values.StartDate}
                  max={getCurrentDate()}
                  required
                />
              </div>

              {/* Search */}
              <button
                type="submit"
                className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
              >
                Search
              </button>

              {/* Reset */}
              <button
                type="button"
                className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                onClick={() => handleReset(resetForm)}
              >
                Reset
              </button>
            </div>

            {/* Export */}
            <div className="mt-4 d-flex">
              <NoOfBinsExport data={noOfBinsGvpData} />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
